
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.833 8.75H5a.833.833 0 000 1.667h.833a.833.833 0 000-1.667zM10 8.75h-.833a.833.833 0 100 1.667H10a.833.833 0 100-1.667zM14.167 8.75h-.834a.833.833 0 000 1.667h.834a.833.833 0 000-1.667zM5.833 12.083H5a.833.833 0 100 1.667h.833a.833.833 0 100-1.667zM10 12.083h-.833a.833.833 0 100 1.667H10a.833.833 0 100-1.667zM14.167 12.083h-.834a.833.833 0 000 1.667h.834a.833.833 0 000-1.667zM5.833 15.417H5a.833.833 0 000 1.666h.833a.833.833 0 100-1.666zM10 15.417h-.833a.833.833 0 000 1.666H10a.833.833 0 100-1.666zM14.167 15.417h-.834a.833.833 0 000 1.666h.834a.833.833 0 000-1.666z","fill":"#35383D"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.208 2.5H17.5c.92 0 1.667.746 1.667 1.667v14.166c0 .92-.747 1.667-1.667 1.667H1.667C.747 20 0 19.254 0 18.333V4.167C0 3.247.746 2.5 1.667 2.5h1.25c.23 0 .416.187.416.417v1.875a.625.625 0 001.25 0V.833a.833.833 0 011.667 0v1.46c0 .114.094.207.208.207h5.209c.23 0 .416.187.416.417v1.875a.625.625 0 001.25 0V.833a.833.833 0 011.667 0v1.459c0 .115.093.208.208.208zm1.875 15.833c.23 0 .417-.186.417-.416v-10a.417.417 0 00-.417-.417h-15a.417.417 0 00-.416.417v10c0 .23.186.416.416.416h15z","fill":"#35383D"}})])
          )
        }
      }
    